export default "__VITE_ASSET__BAaUbBwZ__"